<template>
  <div>
    <md-toolbar
      :class="{
        'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
      }"
      md-elevation="16"
      style="height: 50px"
      align="Center"
    >
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">{{ $route.name }}</h3>
        </div>

        <div
          v-if="$route.name == 'Telemedicine' && telemedicineRoomLink != 'error'"
          class="md-toolbar-section-middle room-link-wrapper"
          @click="copyLink"
        >
          <md-icon style="color: white">content_paste</md-icon>
          <span class="room-link-text">Copy your Telehealth Room Link</span>
          <transition name="fade">
            <span v-show="copyAlert" key="2" class="copy-text"> - Copied!</span>
          </transition>
        </div>
        <div class="md-toolbar-section-end">
          <md-list>
            <md-list-item v-if="$route.name == 'Screening Evaluation'" href="#" @click.prevent="previewRpt">
              <i class="material-icons">print</i>
              <p class="hidden-sm">&nbsp;Preview Rpt</p>
            </md-list-item>

            <!-- <md-list-item v-if="$route.name == 'Screening Evaluation'" href="#" @click.prevent="previewRxRpt">
              <i class="material-icons">medication</i>
              <p class="hidden-sm">&nbsp;Preview Rx</p>
            </md-list-item> -->

            <md-list-item v-if="$route.name == 'Screening Evaluation'" href="#" @click.prevent="toggleImgBox">
              <i class="material-icons">portrait</i>
              <p class="hidden-sm">&nbsp;Images</p>
            </md-list-item>

            <md-list-item v-if="$route.name == 'Screening Evaluation'" href="#" @click="saveAndRedirect">
              <i class="material-icons">save</i>
              <p class="hidden-sm">&nbsp;{{ screeningStatus == "hold" ? "Save" : "Hold" }}</p>
            </md-list-item>

            <md-list-item
              v-if="$route.name == 'Screening Evaluation' && screeningStatus == 'hold'"
              href="#"
              @click="activateScreening"
            >
              <i class="material-icons">done</i>
              <p class="hidden-sm">&nbsp;Release</p>
            </md-list-item>

            <md-list-item href="#" @click="showSwal('logout-confirmation')">
              <i class="material-icons">exit_to_app</i>
              <p class="hidden-sm">&nbsp;Logout</p>
            </md-list-item>
          </md-list>

          <md-button
            class="md-just-icon md-round md-simple md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>
        </div>
      </div>
    </md-toolbar>
  </div>
</template>

<script>
import Swal from "sweetalert2"
import $ from "jquery"
import { bus } from "@/main"

export default {
  data() {
    return {
      onhold: false,
      selectedEmployee: "",
      employees: [],
      copyAlert: false,
      emitCount: 0
    }
  },
  computed: {
    screeningStatus() {
      return this.$store.getters["screeningStatus"].toLowerCase()
    },
    telemedicineRoomLink() {
      if (sessionStorage.getItem("userID")) {
        let url = process.env.VUE_APP_HOST + "/telemedicine/" + sessionStorage.getItem("userID")
        return url
      } else {
        return "error"
      }
    },
    getEmitCount() {
      return this.emitCount++
    }
  },
  methods: {
    previewRpt() {
      // bus.$emit("dxSubmit", null, null, null, null)
      bus.$emit("saveRx")
      bus.$emit("showPreview", "pdfreport")
    },
    previewRxRpt() {
      bus.$emit("showRxPreview", "pdfreport")
    },
    toggleImgBox() {
      bus.$emit("toggleImgBox")
    },
    saveAndRedirect() {
      const status = this.screeningStatus == "hold" ? "Save" : "Hold"
      bus.$emit("executeSave", status)
      bus.$emit("saveFindingsInStorage")
      bus.$emit("saveRx")
    },
    activateScreening() {
      bus.$emit("executeSave", "New")
      bus.$emit("saveFindingsInStorage")
      bus.$emit("saveRx")
    },
    copyLink() {
      let tempInput = $("<input>")
      $("body").append(tempInput)
      tempInput.val(this.telemedicineRoomLink).select()
      document.execCommand("copy")
      tempInput.remove()
      this.toggleCopyAlert()
      return true
    },
    toggleCopyAlert() {
      this.copyAlert = true
      let reset = setTimeout(() => {
        this.copyAlert = false
      }, 2000)
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    showSwal(type) {
      if (type === "logout-confirmation") {
        Swal.fire({
          title: "LOGOUT",
          text: `Are you sure you want to logout?`,
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-info",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("auth/logout").then(() => {
              sessionStorage.clear()
              this.$router.push({ path: "/" })
            })
          }
        })
      } else if (type === "save-message") {
        Swal.fire({
          title: `Evaluation Saved!`,
          text: "...and placed in your on-hold queue.",
          buttonsStyling: false,
          confirmButtonClass: "md-button md-success",
          type: "success"
        }).then((result) => {
          this.onhold = true
          // this.$router.push({ path: "/portal/reader/screenings" });
          this.$router.push({ path: "/portal/reader/onhold" })
        })
      }
    }
  }
}
</script>

<style scoped>
.room-link-text {
  font-weight: 400 !important;
  margin-left: 6px;
}

.hide {
  display: none;
}

.room-link-wrapper {
  cursor: pointer;
}

.copy-text {
  font-weight: 500;
}

.fade-enter-active .fade-lead-active {
  transition: opacity 0.5s;
}

.fade-enter .fade-leave-to {
  opacity: 0;
}
</style>

<style>
.fade-enter-active .fade-lead-active {
  transition: opacity 0.5s;
}

.fade-enter .fade-leave-to {
  opacity: 0;
}
</style>
